<template>
  <div>
    <app-cells><h2 class="title">Allocated beds</h2></app-cells>
    <v-client-table
      :data="table_allocated.items"
      :columns="table_allocated.columns"
      :options="table_allocated.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__clients><div class="table-default__left">Clients</div></template>
      <template #h__created_by><div class="table-default__left">Created by</div></template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.hotel.name }}</div></template>
      <template #check_in="{ row }">{{ dateFormat(row.check_in) }}</template>
      <template #check_out="{ row }">{{ dateFormat(row.check_out) }}</template>
      <template #clients="{ row }">
        <div class="table-default__left table-default__controls">
          <span
            :class="`fflag ff-md fflag-${row.first_room.clients[0].citizenship ? row.first_room.clients[0].citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.first_room.clients[0].citizenship ? row.first_room.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.first_room.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.first_room.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.first_room.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.first_room.clients[0].id } }"
            class="table-default__link-border"
          >
            {{ row.first_room.clients[0].full_name }}
          </router-link>
          <span v-if="row.first_room.clients[0].age">({{ row.first_room.clients[0].age }} y.o.)</span>
          |
          <span
            :class="`fflag ff-md fflag-${row.second_room.clients[0].citizenship ? row.second_room.clients[0].citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.second_room.clients[0].citizenship ? row.second_room.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.second_room.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.second_room.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.second_room.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.second_room.clients[0].id } }"
            class="table-default__link-border"
          >
            {{ row.second_room.clients[0].full_name }}
          </router-link>
          <span v-if="row.second_room.clients[0].age">({{ row.second_room.clients[0].age }} y.o.)</span>
        </div>
      </template>
      <template #created_by="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
              v-tooltip="{ content: `${row.created_by?.full_name || ''}`, placement: 'top-start', offset: 10 }"
            >
          </div>
          {{ dateTimeFormat(row.created_at) }}
        </div>
      </template>
    </v-client-table>
    <app-cells><h2 class="title">Before</h2></app-cells>
    <v-client-table
      :data="table_before.items"
      :columns="table_before.columns"
      :options="table_before.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.reservation.hotel.name }}</div></template>
      <template #check="{ row }">{{ dateFormat(row.check_out) }}</template>
      <template #name="{ row }"><div class="table-default__left table-default__controls">
        <span
          :class="`fflag ff-md fflag-${row.clients[0].citizenship ? row.clients[0].citizenship.code : 'empty'}`"
          v-tooltip="{ content: row.clients[0].citizenship ? row.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
        ></span>
        <img v-if="row.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
        <img v-if="row.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
        <img v-if="!row.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
        <router-link
          :to="{ name: 'clients-detail', params: { id: row.clients[0].id } }"
          class="table-default__link-border"
        >
          {{ row.clients[0].full_name }}
        </router-link>
        <span v-if="row.clients[0].age">({{ row.clients[0].age }} y.o.)</span>
      </div></template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.clients[0].manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.clients[0].manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.clients[0].group">
            <router-link
              :to="{ name: 'clients-groups-general', params: { id: row.clients[0].group.id } }"
              class="table-default__link-border"
            >
              {{ row.clients[0].group.name }}
            </router-link>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
    </v-client-table>
    <app-cells><h2 class="title">After</h2></app-cells>
    <v-client-table
      :data="table_after.items"
      :columns="table_after.columns"
      :options="table_after.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.reservation.hotel.name }}</div></template>
      <template #check="{ row }">{{ dateFormat(row.check_in) }}</template>
      <template #name="{ row }"><div class="table-default__left table-default__controls">
        <span
          :class="`fflag ff-md fflag-${row.clients[0].citizenship ? row.clients[0].citizenship.code : 'empty'}`"
          v-tooltip="{ content: row.clients[0].citizenship ? row.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
        ></span>
        <img v-if="row.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
        <img v-if="row.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
        <img v-if="!row.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
        <router-link
          :to="{ name: 'clients-detail', params: { id: row.clients[0].id } }"
          class="table-default__link-border"
        >
          {{ row.clients[0].full_name }}
        </router-link>
        <span v-if="row.clients[0].age">({{ row.clients[0].age }} y.o.)</span>
      </div></template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.clients[0].manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.clients[0].manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.clients[0].group">
            <router-link
              :to="{ name: 'clients-groups-general', params: { id: row.clients[0].group.id } }"
              class="table-default__link-border"
            >
              {{ row.clients[0].group.name }}
            </router-link>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
    </v-client-table>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getClimbingGroupsBedInTwin, getClimbingGroupsJoinRoomingList, deleteClimbingGroupsJoinRoomingList } from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'ClimbingGroupsDetailBedInTwinOld',
  data() {
    return {
      is_show_flying_block: false,
      item_to_action: null,
      table_before: {
        items: [],
        columns: ['hotel', 'check', 'name', 'group'],
        options: {
          headings: {
            hotel: 'Hotel',
            check: 'Check-out',
            name: 'Full name',
            group: 'Group',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_after: {
        items: [],
        columns: ['hotel', 'check', 'name', 'group'],
        options: {
          headings: {
            hotel: 'Hotel',
            check: 'Check-in',
            name: 'Full name',
            group: 'Group',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_allocated: {
        items: [],
        columns: ['hotel', 'check_in', 'check_out', 'clients', 'created_by'],
        options: {
          headings: {
            hotel: 'Hotel',
            check_in: 'Check-in',
            check_out: 'Check-out',
            clients: 'Clients',
            created_by: 'Created by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.fetchTableBefore()
    this.fetchTableAfter()
    this.fetchTableAllocated()
  },
  methods: {
    fetchTableBefore() {
      getClimbingGroupsBedInTwin(Number(this.$route.params.id), { category: 'before' })
        .then(response => {
          this.table_before.items = response.data
        })
    },
    fetchTableAfter() {
      getClimbingGroupsBedInTwin(Number(this.$route.params.id), { category: 'after' })
        .then(response => {
          this.table_after.items = response.data
        })
    },
    fetchTableAllocated() {
      getClimbingGroupsJoinRoomingList({ climbing_group: Number(this.$route.params.id) })
        .then(response => {
          this.table_allocated.items = response.data
        })
    },
    onDeleteItem() {
      this.$refs.delete.preload = true
      deleteClimbingGroupsJoinRoomingList(this.item_to_action)
        .then(() => {
          this.fetchTableBefore()
          this.fetchTableAfter()
          this.fetchTableAllocated()
          this.$modal.hide('delete-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
